import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { InactiveCustomersActions } from "./inactive-customers.actions";
import { SendReminderActions } from "../send-reminder/send-reminder.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update developer state within PagesStore
// **************************************************************************

function withDeveloper(state: PagesStore, updater: (developer: DeveloperState) => DeveloperState): PagesStore {
    return { ...state, developer: updater(state.developer) };
}

// **************************************************************************
// INACTIVE CUSTOMERS REDUCER (array format for PagesStore)
// **************************************************************************

const load = on(InactiveCustomersActions.load, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    inactiveCustomers: { ...developerState.inactiveCustomers, loading: true },
    error: null,
})));

const loadSuccess = on(InactiveCustomersActions.loadSuccess, (state: PagesStore, { customers }) => withDeveloper(state, developerState => ({
    ...developerState,
    inactiveCustomers: { ...developerState.inactiveCustomers, customers, loading: false },
    error: null,
})));

const loadFailure = on(InactiveCustomersActions.loadFailure, (state: PagesStore, { error }) => withDeveloper(state, developerState => ({
    ...developerState,
    inactiveCustomers: { ...developerState.inactiveCustomers, loading: false },
    error,
})));

// Cross-feature dependency: Update customer's lastMarketingEmailDate when reminder is sent
const updateAfterReminder = on(SendReminderActions.sendSuccess, (state: PagesStore, { customerSystemId }) => withDeveloper(state, developerState => ({
    ...developerState,
    inactiveCustomers: {
        ...developerState.inactiveCustomers,
        customers: developerState.inactiveCustomers.customers?.map(c =>
            c.customerSystemId === customerSystemId
                ? { ...c, lastMarketingEmailDate: new Date() }
                : c,
        ),
    },
})));

export const inactiveCustomersReducer = [
    load,
    loadSuccess,
    loadFailure,
    updateAfterReminder,
];
